
import { InitRequestPayload } from "appworks/model/gameplay/requests/init-request-payload";
import { commsManager } from "appworks/server/comms-manager";

export function InitCommand() {
    return commsManager.request(new InitRequestPayload());
}
